<template>
  <div v-if="lastUpdated" class="d-flex h-100">
    <div class="d-flex align-center" data-tourid="dashboard-last-updated">
      <p class="ma-0 pa-0 font-size-12 blue-grey--text text--darken-1">
        {{ $t('insights.last_update') }}
        {{ lastUpdated }}
      </p>
      <v-tooltip bottom min-width="300" max-width="310">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" color="blue-grey" size="16" class="ms-2"
            >mdi-information-outline</v-icon
          >
        </template>
        {{ $t('insights.last_update_helper') }}
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { utils } from 'frontend-js-shared'

import mixin from '@/mixins/mixin.vue'

export default {
  name: 'InsightsLastUpdatedLabel',

  mixins: [mixin],

  data() {
    return {
      lastUpdated: null,
    }
  },

  mounted() {
    this.getLastUpdatedDate()
  },

  watch: {
    language(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getLastUpdatedDate()
      }
    },
  },

  computed: {
    ...mapGetters(['account', 'organizationId', 'language']),
  },

  methods: {
    ...mapActions({
      getReport: 'report/getReport',
    }),

    async getLastUpdatedDate() {
      try {
        const data = await this.getReport({
          organizationId: this.organizationId,
          options: {
            type: 'last-updated-at',
            startDate: utils.dates.getStartOfDay(new Date().toISOString()),
            endDate: utils.dates.getEndOfDay(new Date().toISOString()),
          },
        })

        const date = utils.dates.convertUTCtoTimezone(
          data.approximatedLastUpdatedAt,
          null,
          this.account.timezone
        )

        this.lastUpdated = utils.dates.humanDate(date).toLowerCase()
      } catch (err) {
        this.handleRequestError(err)
      }
    },
  },
}
</script>

<style></style>
